import { ApiResponse, TokenData, IExteriorColor } from '../models';
import * as http from './http';
import ApiService from './service';

export class ExteriorColorService extends ApiService {
  public async loadAllExteriorColors(): Promise<IExteriorColor[]> {
    const url = `${this.apiDomain}/api/trade-in/exterior-color`;

    const resposne = await http.get<ApiResponse<IExteriorColor[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }

  public async updateExteriorColor(data: IExteriorColor, id?: string) {
    const url = `${this.apiDomain}/api/trade-in/exterior-color/${id}`;

    const response = await http.put<ApiResponse<IExteriorColor>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async createExteriorColor(data: IExteriorColor) {
    const url = `${this.apiDomain}/api/trade-in/exterior-color`;

    const response = await http.post<ApiResponse<IExteriorColor>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteExteriorColor(id?: string) {
    const url = `${this.apiDomain}/api/trade-in/exterior-color/${id}`;

    const response = await http.remove<ApiResponse<IExteriorColor>>(
      url,
      this.store
    );
    return response.data;
  }
}
